/** @format */

import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { LoaderComponent } from '../loader/loader.component';
import { TabsetDirective } from './directives/tabset.directive';

@Component({
  selector: '[mbsTabsetOutlet]',
  styleUrls: ['./tabset-content-outlet.component.scss'],
  templateUrl: './tabset-content-outlet.component.html',
  imports: [LoaderComponent, NgTemplateOutlet],
  host: {
    '[class]': 'hostClass'
  }
})
export class TabsetContentOutlet {
  protected readonly hostClass = 'mbs-tabset_content';
  /**
   * Reference to the `mbsTabset` instance
   */
  public readonly nav = input<TabsetDirective>(null, { alias: 'mbsTabsetOutlet' });
}
